/**
 *  年级
 */
export const Grade = [
  { id: 'null', value: '全部' },
  { id: 'FIRST_GRADE', value: '一年级' },
  { id: 'SECOND_GRADE', value: '二年级' },
  { id: 'THIRD_GRADE', value: '三年级' },
  { id: 'FOURTH_GRADE', value: '四年级' },
  { id: 'FIFTH_GRADE', value: '五年级' },
  { id: 'SIXTH_GRADE', value: '六年级' },
  { id: 'SEVEN_GRADE', value: '七年级' },
  { id: 'EIGHTH_GRADE', value: '八年级' },
  { id: 'NINTH_GRADE', value: '九年级' },
  { id: 'HIGH_FIRST', value: '高一' },
  { id: 'HIGH_SECOND', value: '高二' },
  { id: 'HIGH_THIRD', value: '高三' },
]

export function getGradeName(val) {
  let res = ''
  Grade.forEach(item => {
    if (item.id === val) {
      res = item.value
    }
  })
  return res
}

/**
 *  科目
 */
export const Subject = [
  { label: '语文', value: 'CHINESE' },
  { label: '数学', value: 'MATHEMATICS' },
  { label: '英语', value: 'ENGLISH' },
  { label: '物理', value: 'PHYSICS' },
  { label: '化学', value: 'CHEMISTRY' },
  { label: '生物学', value: 'BIOLOGY' },
  { label: '历史', value: 'HISTORY' },
  { label: '地理', value: 'GEOGRAPHY' },
  { label: '道德与法治', value: 'MORALITY_AND_RULE_OF_LAW' },
  { label: '思想政治', value: 'POLITICS' },
  { label: '体育与健康', value: 'SPORTS_AND_HEALTH' },
  { label: '艺术·音乐', value: 'MUSIC' },
  { label: '艺术·美术', value: 'FINE_ARTS' },
  { label: '科学', value: 'SCIENCE' },
  { label: '信息科技', value: 'INFORMATION_TECHNOLOGY' },
  { label: '通用技术', value: 'GENERAL_TECHNOLOGY' },
  { label: '劳动与技术', value: 'LABOR_AND_TECHNOLOGY' },
  { label: '心理健康', value: 'MENTAL_HEALTH' },
  { label: '安全教育', value: 'SAFETY_EDUCATION' },
  { label: '综合实践活动', value: 'INTEGRATED_PRACTICE_ACTIVITY' },
  { label: '少先队活动', value: 'YOUNG_PIONEER_ACTIVITIES' },
]

export function getSubjectName(val) {
  let res = ''
  Subject.forEach(item => {
    if (item.value === val) {
      res = item.label
    }
  })
  return res
}

/**
 *  学段
 */
 export const SubsectionList = [
  {
    label: '小学',
    value: 'PRIMARY_SCHOOL'
  },
  {
    label: '初中',
    value: 'JUNIOR_HIGH_SCHOOL'
  },
  {
    label: '高中',
    value: 'HIGH_SCHOOL'
  }
]

export function getSubsectionName(val) {
  let res = ''
  SubsectionList.forEach(item => {
    if (item.value === val) {
      res = item.label
    }
  })
  return res
}

/**
 *  防抖函数
 */
export function debounce(fn, wait) {
  let timeout = null
  wait = wait || 600
  return function () {
    let that = this
    if (timeout !== null) clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(that)
    }, wait)
  }
}